define('studio/laser-list',["require", "exports", "../baseline/lasers", "../baseline/search", "../tracks/track-enabled", "../tracks/track-state"], function (require, exports, laserApi, search_1, trackEnabled, trackState) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.LaserList = void 0;
    /**
     * View controller for laser profile listing
     */
    var LaserList = /** @class */ (function () {
        function LaserList(userId) {
            var _this = this;
            // HTML Elements
            this.element = document.getElementById("studio-laser-list");
            this.listDiv = document.getElementById("studio-laser-list-items");
            this.searchBox = document.getElementById("studio-laser-list-search");
            this.lasers = [];
            this.userId = userId;
            // Bind to search box
            this.searchBox.onkeyup = function () {
                _this.render();
            };
            this.update();
        }
        LaserList.prototype.update = function () {
            var _this = this;
            // Get laser profiles
            var futureLasers = this.userId ? laserApi.byUser(this.userId) : laserApi.getPublic();
            futureLasers.then(function (lasers) {
                _this.lasers = lasers;
                _this.render();
            });
        };
        // Render list of lasers
        LaserList.prototype.render = function () {
            var _this = this;
            var searchString = this.searchBox.value;
            var lasersPrivate = this.lasers.filter(function (l) { return _this.isMine(l); })
                .sort(LaserList.laserCompare);
            var lasersPublic = this.lasers.filter(function (l) { return !_this.isMine(l) && l.public; })
                .sort(LaserList.laserCompare);
            var lasersAll = this.lasers.filter(function (l) { return !_this.isMine(l) && !l.public; })
                .sort(LaserList.laserCompare);
            this.listDiv.innerText = "";
            // Add private
            if (this.userId) {
                this.addMyHeader();
                lasersPrivate
                    .filter(function (laser) { return (0, search_1.matchLaser)(laser, searchString); })
                    .forEach(function (laser) { return _this.addLaser(laser); });
            }
            // Add public
            if (lasersPublic.length > 0) {
                this.addPublicHeader();
                lasersPublic
                    .filter(function (laser) { return (0, search_1.matchLaser)(laser, searchString); })
                    .forEach(function (laser) { return _this.addLaser(laser); });
            }
            // Add remaining
            if (lasersAll.length > 0) {
                this.addAllHeader();
                lasersAll
                    .filter(function (laser) { return (0, search_1.matchLaser)(laser, searchString); })
                    .forEach(function (laser) { return _this.addLaser(laser); });
            }
            if (!lasersPublic && !lasersPrivate && !lasersAll) {
                this.listDiv.innerText = "laser profiles not found";
            }
        };
        LaserList.prototype.isMine = function (laser) {
            return this.userId !== undefined && laser.user_id === this.userId;
        };
        LaserList.prototype.addMyHeader = function () {
            var headerDiv = document.createElement("div");
            headerDiv.innerText = "My Profiles";
            headerDiv.classList.add("studio-header");
            this.listDiv.appendChild(headerDiv);
        };
        LaserList.prototype.addPublicHeader = function () {
            var headerDiv = document.createElement("div");
            headerDiv.innerHTML = "<div>Public Profiles</div>\n<p>Warning: Profiles submitted by the community may be inaccurate. Always measure yourself.</p>";
            headerDiv.classList.add("studio-header");
            this.listDiv.appendChild(headerDiv);
        };
        LaserList.prototype.addAllHeader = function () {
            var headerDiv = document.createElement("div");
            headerDiv.innerHTML = "All Profiles";
            headerDiv.classList.add("studio-header");
            this.listDiv.appendChild(headerDiv);
        };
        LaserList.prototype.addLaser = function (laser) {
            var laserDiv = document.createElement("div");
            var subtitle = "&nbsp;";
            if (laser.place && laser.place.region) {
                subtitle = laser.place.region + ", " + laser.place.country;
            }
            else if (laser.place) {
                subtitle = laser.place.country;
            }
            laserDiv.innerHTML = "\n      <div>\n        <label>" + laser.name + "</label>\n        <div>" + subtitle + "</div>\n      </div>\n      <a href=\"/lasers/" + laser.laser_id + "\" class=\"open-link\"></a>";
            laserDiv.classList.add("studio-item");
            // Subscribe to enabled state
            trackEnabled.observe(laser.laser_id).subscribeNow(function (isEnabled) {
                if (isEnabled) {
                    laserDiv.classList.add("active");
                }
                else {
                    laserDiv.classList.remove("active");
                }
            });
            laserDiv.addEventListener("click", function () {
                if (trackEnabled.isEnabled(laser.laser_id)) {
                    trackEnabled.remove(laser.laser_id);
                }
                else {
                    trackEnabled.addLaser(laser);
                }
            });
            laserDiv.addEventListener("mouseover", function () {
                if (trackEnabled.isEnabled(laser.laser_id)) {
                    trackState.highlight.set(laser.laser_id);
                }
            });
            laserDiv.addEventListener("mouseout", function () { return trackState.highlight.set(undefined); });
            this.listDiv.appendChild(laserDiv);
        };
        /* Comparator to sort by country, by name */
        LaserList.laserCompare = function (laser1, laser2) {
            var stringify = function (laser) { return (laser.place && laser.place.country) + " - " + laser.name; };
            return stringify(laser1).localeCompare(stringify(laser2));
        };
        return LaserList;
    }());
    exports.LaserList = LaserList;
});
//# sourceMappingURL=/assets/javascripts/studio/laser-list.js.map;
